import { render, staticRenderFns } from "./NewFormModal.vue?vue&type=template&id=06481c19&"
import script from "./NewFormModal.vue?vue&type=script&lang=js&"
export * from "./NewFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports